// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "crn",
                Decco.stringToJson(v.crn)
              ],
              [
                "has_waypoint",
                Decco.boolToJson(v.has_waypoint)
              ],
              [
                "order_updated_at",
                Decco.floatToJson(v.order_updated_at)
              ]
            ]);
}

export {
  t_encode ,
  
}
/* No side effect */
